import { useOnScreen } from '@dreamstack/util'
import first from 'lodash/first'
import last from 'lodash/last'
import split from 'lodash/split'
import type { FunctionComponent} from 'react';
import React, { useEffect, useRef } from 'react'

export const EmbeddedYoutubeVideo: FunctionComponent<React.PropsWithChildren<{
  fullYoutubeUrl: string
  autoPlayWhenOnScreen?: boolean
}>> = ({ fullYoutubeUrl, autoPlayWhenOnScreen = false }) => {
  const ref = useRef<HTMLIFrameElement | null>(null)
  const onScreen = useOnScreen(ref)

  useEffect(() => {
    if (ref?.current) {
      if (!onScreen) {
        ref.current.contentWindow?.postMessage(
          '{"event":"command","func":"pauseVideo","args":""}',
          '*'
        )
      } else {
        if (autoPlayWhenOnScreen) {
          ref.current.contentWindow?.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            '*'
          )
        }
      }
    }
  }, [autoPlayWhenOnScreen, onScreen])

  const lastUrlPart = last(split(fullYoutubeUrl, '/'))
  let embedId = last(split(lastUrlPart, '='))
  embedId = first(split(embedId, '#'))
  const youtubeEmbedLink = `https://www.youtube.com/embed/${embedId}?rel=0&enablejsapi=1`
  return (
    <>
      <iframe
        width="100%"
        height="100%"
        src={youtubeEmbedLink}
        frameBorder="0"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        title="Embedded Video"
        ref={ref as React.LegacyRef<HTMLIFrameElement> | undefined}
      />
    </>
  )
}
